import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import catta, { ajax } from 'catta'
import axios from 'axios'

// Styles
import styles from './styles'

// Material UI
import { withStyles } from 'material-ui/styles'
import Typography from 'material-ui/Typography'

// Components
import Row from '../../components/Row'
import RowDetails from '../../components/RowDetails'
import Loader from '../../../../../../components/Loader'

class Start extends Component {
  constructor(props) {
    super(props)

    this.state = {
      data: [],
      iteration: 0,
      dataPrePopulation: [],
      appendingArray: [],
      loading: true,
      income_levels: [
        'Everyone',
        '$25,000+',
        '$35,000+',
        '$50,000+',
        '$75,000+',
        '$100,000+',
        '$150,000+'
      ],
      education_levels: [
        'High School',
        'Some College',
        'Associate Degree',
        'Bachelor Degree',
        'Graduate Degree',
        'PHD / Post Doctoral'
      ]
    }
  }

  async getPopulationCounts() {
    if (this.state.dataPrePopulation.length > 0) {
      let myComponent = this
      let data = this.state.dataPrePopulation
      let i = this.state.iteration
      let savedSearch = data[i]
      let appendingArray = this.state.appendingArray
      let url = ''
      if (savedSearch['Search_Name'] === 'All Candidates') {
        url = `https://dsn-dev.appspot.com/v1/proxy?url=https://api.dsnapis.com/count/0/pw/teSt1/ssrch/4/db/2/dschigh/4/dsclow/0/agehigh/42/agelow/41/oarhigh/9/oarlow/8/herprefage/50/herprefans/0/clrhigh/5/clrlow/1/education/0/income/0/cust/${
          this.props.customer_number
        }`
      } else {
        let education = savedSearch.Education_Low
        let income = savedSearch.Income_Low
        if (education == 0) {
          education = -1
        }
        if (income == 0) {
          income = -1
        }

        url =
          'https://dsn-dev.appspot.com/v1/proxy?url=https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/4/dsclow/0/agehigh/' +
          savedSearch.Oldest_Dating_Age +
          '/agelow/' +
          savedSearch.Youngest_Dating_Age +
          '/oarhigh/' +
          savedSearch.Oar_High +
          '/oarlow/' +
          savedSearch.Oar_Low +
          '/herprefage/' +
          savedSearch.Profile_Oldest_Dating_Age +
          '/herprefans/' +
          savedSearch.Include_NA +
          '/clrhigh/5/clrlow/1/education/' +
          education +
          '/income/' +
          income +
          '/cust/' +
          this.props.customer_number
      }

      /*
      'https://dsn-dev.appspot.com/v1/proxy?url=https://api.dsnapis.com/count/1/pw/teSt1/ssrch/4/db/2/dschigh/5/dsclow/0/agehigh/'+this.props.agehigh+'/agelow/'+this.props.agelow+'/oarhigh/'+this.props.oarhigh+'/oarlow/'+this.props.oarlow+'/herprefage/'+this.props.old_age+'/herprefans/'+this.props.pref_fans+'/clrhigh/5/clrlow/1/education/'+education+'/income/'+income+'/cust/'+this.props.customer_number,
      }).then(function(response) {
      */
      //alert(savedSearch.Include_NA);
      //alert(JSON.stringify(savedSearch.Oldest_Dating_Age))
      //alert(url)

      await axios.get(url).then(function(response) {
        if (response.data[0]['SearchCount']) {
          let searchCount = response.data[0]['SearchCount']
          savedSearch['searchCount'] = searchCount
          appendingArray.push(savedSearch)

          myComponent.setState(
            {
              appendingArray: appendingArray
            },
            function() {
              if (i < data.length - 1) {
                let next = i + 1
                myComponent.setState(
                  {
                    iteration: next
                  },
                  function() {
                    myComponent.getPopulationCounts()
                  }
                )
              } else {
                this.setState(
                  {
                    data: this.state.appendingArray
                  },
                  function() {
                    //alert(JSON.stringify(this.state.appendingArray))
                  }
                )
              }
            }
          )
        } else {
          myComponent.getPopulationCounts()
        }
      })
    }
  }

  async getData() {
    let currentComponent = this

    let url = `https://dsn-dev.appspot.com/v1/proxy?url=https://api.dsnapis.com/cust/${
      this.props.customer_number
    }/pw/teSt1/ssrch/0`
    //alert(url)
    await axios.get(url).then(function(response) {
      console.log(response.data[0])
      if (Array.isArray(response.data)) {
        currentComponent.setState(
          {
            dataPrePopulation: response.data
          },
          function() {
            currentComponent.getPopulationCounts()
          }
        )
      } else {
        currentComponent.getData()
      }
    })
  }

  componentDidMount() {
    this.getData()
  }

  render() {
    const { classes, theme, location } = this.props

    if (this.state.data.length > 0) {
      return (
        <div className={classes.root}>
          <Typography>These are your saved searches:</Typography>
          {this.state.data.map(function(savedsearch, index) {
            return <Row data={savedsearch} />
          })}
        </div>
      )
    } else {
      return <Loader />
    }
  }
}

function mapStateToProps(state) {
  return {
    customer_number: state.customer.number,
    project_id: state.prefix.project_id
  }
}

export default withRouter(
  withStyles(styles, { withTheme: true })(connect(mapStateToProps)(Start))
)



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Search/scenes/SavedSearches/scenes/Start/index.js